var exports = {
  "$": "pendingComment__FHZMRB",
};

module.exports = exports;
